import React, { useContext, useEffect } from 'react';
import { WidgetsContext } from './GlobalContex';
import Loader from './components/loader/Loader';
import Layouts from './components/layouts/Layouts';
import BuilderRoute from './routing/BuilderRoute';
import { AppLayout } from './routing/AppLayout/AppLayout';
import { NotificationProvider } from './hooks/useNotifications';
import { AnalyticsProvider } from './hooks/useAnalytics';
import {
  HashRouter as Router,
  useRoutes,
  useParams,
  Outlet
} from 'react-router-dom';
import './App.scss';

function Widget() {
  const { publicId } = useParams();
  const { activeWidget, setActiveWidget, setWidgets } = useContext(WidgetsContext);

  useEffect(() => {
    const widget = {
      id: Date.now(),
      app: {},
      code: '',
      publicId,
      settings: {}
    };
    setWidgets([widget]);
    setActiveWidget(widget);
  }, [publicId]);

  if (!activeWidget.id) {
    return null;
  }

  return <Outlet />;
}

const Routes = () => {
  return useRoutes([
    {
      path: '/demo/:publicId',
      element: <Widget />,
      children: [
        {
          element: <AppLayout />,
          children: [
            { path: 'styles', element: <Layouts /> },
            { path: 'builder', element: <BuilderRoute /> }
          ]
        }
      ]
    }
  ]);
};

const App = () => {
  return (
      <NotificationProvider>
        <Loader>
          <Router>
            <AnalyticsProvider>
              <Routes />
            </AnalyticsProvider>
          </Router>
        </Loader>
      </NotificationProvider>
  );
};

export default App;
